export enum ThemeType {
    None = 'None',
    Primary = 'Primary',
    Secondary = 'Secondary'
}
